if (!customElements.get('ae-symbol')) {
  customElements.define('ae-symbol', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-symbol-interest]');
        if (!trigger) return;
        const select = this.querySelector('#SymbolInterest');
        if (!select) return;
        const option = Array.from(select.options).find(item => item.value === trigger.dataset.symbolInterest);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
}



